import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import AboutSection from "./components/AboutSection"; 
import TeamSection from "./components/TeamSection"; 
import Sponsors from "./components/Sponsors";
import Gallery from "./components/Gallery";
import Registration from "./components/Registration";
import FormularioInscricao from "./components/FormularioInscricao"; // Importe o formulário separado
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Terms from './components/ui/terms';
import Privacy from './components/ui/privacy';
import Store from './components/ui/Store';
import { Toaster } from "./components/ui/sonner";

// Home agora mostra apenas os detalhes e o botão de interesse
const Home = () => (
  <>
    <Hero />
    <AboutSection /> 
    <TeamSection />  
    <Gallery />
    <Sponsors />    
    <Registration /> {/* Aqui fica apenas o card de detalhes com o botão */}
    <Contact />
  </>
);

function App() {
  return (
    <Router>
      <div className="App relative isolate min-h-screen bg-[#05040a]">
        <Navbar />
        <Toaster position="top-center" richColors />
        
        <Routes>
          {/* Rota Principal */}
          <Route path="/" element={<Home />} />
          
          {/* ROTA DO FORMULÁRIO (O "Lugar Novo" que estava dando 404) */}
          <Route path="/inscricao" element={<FormularioInscricao />} />
          
          {/* Outras Rotas */}
          <Route path="/termos" element={<Terms />} />
          <Route path="/privacidade" element={<Privacy />} />
          <Route path="/loja" element={<Store />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;